module.exports = __webpack_public_path__ + "officialStatic/img/product-xysh.032e08c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-xysh.png
// module id = gOSR
// module chunks = 0